import { IGetLoginsResponse } from "domain/IGetLoginsResponse";
import { ILogin } from "domain/ILogin";
import { IMessage } from "domain/IMessage";
import API from "utils/API";
import authHeader from "utils/auth-header";

const getNumberOfUnseenMessages = async (): Promise<any> => {
  var headers = authHeader();
  try {
    const response = await API.get<any>(
      "/chat/protected/chat/unseen-count",
      { headers }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

const seeUnseenMessages = async (messageId: number): Promise<IMessage> => {
  var headers = authHeader();
  try {
    const response = await API.put<IMessage>(
      "/chat/protected/chat/see",
      { lastSeenMessageId: messageId },
      { headers }
    );
    let message = response.data;
    return message;
  } catch (err) {
    throw err;
  }
};

const getNumberOfNotAcceptedRequisitions = async (): Promise<any> => {
  var headers = authHeader();
  try {
    const response = await API.get<any>(
      "/requisitions/protected/not-accepted-requisitions-count",
      { headers }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

const getNumberOfUnseenReports = async (): Promise<any> => {
  var headers = authHeader();
  try {
    const response = await API.get<any>(
      "/reports/protected/report/unseen-count",
      { headers }
    );
    return response;
  } catch (err) {
    throw err;
  }
};

const getMyLogins = async (): Promise<ILogin[]> => {
  var headers = authHeader();
  try {
    const response = await API.get<IGetLoginsResponse>(
      "/authentication/public/my-logins",
      { headers }
    );
    return response.data.sessions;
  } catch (err) {
    throw err;
  }
};

export const dashboardService = {
  getNumberOfUnseenMessages,
  seeUnseenMessages,
  getNumberOfNotAcceptedRequisitions,
  getNumberOfUnseenReports,
  getMyLogins,
};
